<template>
<div class="contract_info_area" id='contract_info'>
  <div class="edit_area_half">
    <inputBindSection :titleLabel='corporationNameLabel'
                    :bindValue='corporation.corporationName'
                    @inputUpdate="inputUpdate('corporationName')"></inputBindSection>
    <inputBindSection :titleLabel='corporationAddressLabel'
                    :bindValue='corporation.corporationAddress'
                    @inputUpdate="inputUpdate('corporationAddress')"></inputBindSection>
    <inputBindSection :titleLabel='corporationUserDepartmentsLabel'
                    :notRequiredFlag='true'
                    :bindValue='corporation.corporationUserDepartments'
                    @inputUpdate="inputUpdate('corporationUserDepartments')"></inputBindSection>
    <inputBindSection :titleLabel='corporationUserPositionLabel'
                    :notRequiredFlag='true'
                    :bindValue='corporation.corporationUserPosition'
                    @inputUpdate="inputUpdate('corporationUserPosition')"></inputBindSection>
    <inputBindSection :titleLabel='corporationUserNameLabel'
                    :bindValue='corporation.corporationUserName'
                    @inputUpdate="inputUpdate('corporationUserName')"></inputBindSection>
  </div>
  <div class="edit_area_half">
    <inputBindSection :titleLabel='corporationUserTelephoneNumberLabel'
                    :bindValue='corporation.corporationUserTelephoneNumber'
                    @inputUpdate="inputUpdate('corporationUserTelephoneNumber')"></inputBindSection>
    <inputBindSection :titleLabel='corporationUserMailAddressLabel'
                    :bindValue='corporation.corporationUserMailAddress'
                    @inputUpdate="inputUpdate('corporationUserMailAddress')"></inputBindSection>
    <datepickerSection :titleLabel='contractDateLabel'
                    :placeholderValue='corporation.contractDate'
                    @inputUpdate="inputUpdate('contractDate')"></datepickerSection>
    <inputBindSection :titleLabel='availableDeviceCountsLabel'
                    :bindValue='corporation.availableDeviceCounts'
                    @inputUpdate="inputUpdate('availableDeviceCounts')"></inputBindSection>
  </div>
</div>
</template>

<script>
import inputBindSection from './inputBindSection.vue'
import datepickerSection from './datepickerSection.vue'
import valueLabelSection from './valueLabelSection.vue'

export default {
  data () {
    return {
      corporationNameLabel: '法人名',
      corporationAddressLabel: '法人住所',
      contractDateLabel: '契約日',
      corporationUserDepartmentsLabel: '法人担当者（部署）',
      corporationUserPositionLabel: '法人担当者（役職）',
      corporationUserNameLabel: '法人担当者（氏名）',
      corporationUserTelephoneNumberLabel: '法人担当者連絡先（電話）',
      corporationUserMailAddressLabel: '法人担当者連絡先（メール）',
      availableDeviceCountsLabel: '契約台数'
    }
  },
  components: {
    inputBindSection,
    datepickerSection,
    valueLabelSection
  },
  computed: {
    corporation () {
      return this.$store.state.corporations.corporation
    }
  },
  methods: {
    inputUpdate (e) {
      this.$store.dispatch('corporations/inputUpdate', {name: e, value: event.target.value})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/contractEditInfo.vue